import axios from 'axios'

const api = async (method, path, params) => axios[method](path, params)

const state = {}

const mutations = {}

const actions = {
    async createInventory(context, payload) {
        try {
            await api('post', `inventory`, payload)
        } catch (err) {
            throw err
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
